import { cn } from "@utils";

const SwitchLabel = ({ children, htmlFor, className }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        "block text-sm/6 font-medium text-zinc-900 max-w-64",
        className
      )}
    >
      {children}
    </label>
  );
};

export default SwitchLabel;
